import React from 'react';

const PageHeading = ({ 
  children, 
  size = 'hero',
  className = '', 
  subtitle = '',
  containerClass = '',
  actions = null,
  ...props 
}) => {
  const baseClasses = 'font-sans text-neutral-900 tracking-tight font-medium';
  
  const sizeClasses = {
    hero: 'text-hero',
    'hero-lg': 'text-hero-lg',
  };

  const classes = `${baseClasses} ${sizeClasses[size]} ${className}`;

  return (
    <div className={`page-heading-container hairline min-h-[32vh] md:min-h-[48vh] relative ${containerClass}`}>
      {actions && (
        <div className="absolute bottom-3 right-3 md:bottom-4 md:right-4 z-10">
          {actions}
        </div>
      )}
      <div className="page-heading-content absolute bottom-0 left-2 right-2 md:left-4 md:right-4">
        <h1 className={classes} {...props}>
          {children}
        </h1>
        {subtitle && (
          <p className="page-heading-subtitle font-mono uppercase tracking-wider text-neutral-900 opacity-60 mt-0 text-sm md:text-lg">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeading; 
